import TwoColumnImageBlock from './two-column-images';
import VideoBlock from "./video";
import TabsBlock from "./tabs";
var aboutUsBlocks = document.querySelector('[data-about-us-block]');
var twoColumnImageBlocks = aboutUsBlocks.querySelectorAll('[data-two-column-image-block]');
twoColumnImageBlocks.forEach(function (twoColumnImageBlock) {
    new TwoColumnImageBlock(twoColumnImageBlock);
});
var videoBlocks = aboutUsBlocks.querySelectorAll('[data-video-block]');
videoBlocks.forEach(function (videoBlock) {
    new VideoBlock(videoBlock);
});
var tabsBlocks = aboutUsBlocks.querySelectorAll('[data-tab-block]');
tabsBlocks.forEach(function (tabsBlock) {
    new TabsBlock(tabsBlock);
});
